import React from "react";
import EmbeddedCallPanel from "@/components/EmbeddedMeetPanel";
import { useCall } from "@/contexts/CallContext";
import { X } from "lucide-react";

/**
 * Persistent, route-independent floating call host. Rendered ONCE in <App />
 * so that navigating between pages keeps the iframe alive.
 */
export default function PersistentCallHost() {
  const { call, endCall } = useCall();
  if (!call) return null;

  // Google Meet cannot be embedded (X-Frame-Options DENY). We surface a
  // persistent mini card with a deep-link instead so it also survives route
  // changes.
  if (call.provider === "google_meet" && call.meetingUri) {
    return (
      <div className="fixed top-4 right-4 z-[120] w-[360px] bg-white border border-slate-200 rounded-sm shadow-2xl" data-testid="persistent-gmeet-panel">
        <div className="flex items-center gap-2 px-3 py-2.5 bg-kb-ink text-white">
          <div className="flex-1 text-xs font-medium">Google Meet · in progress</div>
          <button onClick={endCall} className="p-1 text-white/70 hover:text-white" data-testid="persistent-gmeet-close">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="p-4 space-y-3">
          <p className="text-xs text-kb-ink-muted">
            Google Meet can&apos;t embed in-page. The tab you opened stays live — this pin travels with you across pages.
          </p>
          <a href={call.meetingUri} target="_blank" rel="noreferrer" className="kb-btn-primary text-sm w-full justify-center" data-testid="persistent-gmeet-open-btn">
            Re-open Google Meet
          </a>
        </div>
      </div>
    );
  }

  return (
    <EmbeddedCallPanel
      roomUrl={call.roomUrl}
      displayName={call.displayName}
      audioOnly={!!call.audioOnly}
      onClose={endCall}
    />
  );
}
